// Entry component for /releases/profiles/new.
//
// We've committed to the data-confident layout: a wide hero
// inspection panel keyed off the picked bundle, a compact source
// rail on the left, and a sticky commit footer that materialises
// once a bundle resolves. The page renders full-width so it lines
// up with the other release surfaces (ProfilesReleases,
// ChromiumReleases, ReleasesOverview) inside the SidebarInset.

import { usePublishProfilesController } from "./release-new-profiles/use-publish-profiles-controller";
import { DataConfidentView } from "./release-new-profiles/views/data-confident";

export function ReleaseNewProfiles() {
	const controller = usePublishProfilesController();
	return (
		<div className="flex w-full flex-col gap-6">
			<DataConfidentView controller={controller} />
		</div>
	);
}
